import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { listInventaireDiamant } from '../../redux/slices/stock-diamant.slice';
import {
  Box,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PageContainer from '../../components/container/PageContainer';
import Breadcrumb from '../../layouts/full-layout/breadcrumb/Breadcrumb';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

const BCrumb = [
  {
    to: '/app',
    title: 'Home',
  },
  {
    title: 'Inventaire Diamant',
  },
];

const InventaireDiamantListContainer = () => {
  const dispatch = useDispatch();
  const [lst_inventaire, set_lst_inventaire] = useState([]);
  const [filter, set_filter] = useState({ search: '' });

  const load_data = () => {
    dispatch(listInventaireDiamant())
      .unwrap()
      .then((res) => {
        set_lst_inventaire(Array.isArray(res?.data) ? res?.data : []);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    load_data();
  }, []);
  return (
    <PageContainer title="Inventaire Diamant" description="">
      {/* breadcrumb */}
      <Breadcrumb title="Inventaire Diamant" items={BCrumb} />
      <Box textAlign={'end'}>
        <Link to={'create'}>
          <Button size="small" color="success" variant="contained" onClick={() => {}}>
            <FeatherIcon width={14} icon="plus" />
            Nouveau Inventaire
          </Button>
        </Link>
      </Box>
      <InventaireDiamantList lst_inventaire={lst_inventaire} />
    </PageContainer>
  );
};

const InventaireDiamantList = ({ lst_inventaire }) => {
  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Num</TableCell>
            <TableCell sx={{ textAlign: 'center' }}>Status</TableCell>
            <TableCell>Article</TableCell>
            <TableCell>Créer par</TableCell>
            <TableCell>Créer le</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lst_inventaire.map((row) => (
            <TableRow key={row?.ref}>
                <Link to={`details/${row?.idInventaireDia}`}>
              <TableCell sx={{ color: 'primary.main', fontWeight: 500 }}>{row?.ref}</TableCell>
              </Link>
              <TableCell sx={{ textAlign: 'center' }}>
                <Chip size='small' sx={{ borderRadius: 1 }} color={row?.status === 'en-cours' ? 'success' : 'default'} label={row?.status} />
              </TableCell>
              {/* <TableCell
                sx={{ textAlign: 'center' }}
              >{`${row?.date_debut} - ${row?.date_fin}`}</TableCell> */}
              <TableCell sx={{ color: 'success.main' }}>
                {Array.isArray(row?.stock_trouvee) ? row?.stock_trouvee?.length : 0}
              </TableCell>
              <TableCell>{row.owner}</TableCell>
              <TableCell>{String(row?.created_at).substring(0, 10)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InventaireDiamantListContainer;
